const projectHeaderReducer = (
    state = {
      data: [],
    },
    action: {
      type: "SET_PROJECT_HEADER_LIST";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_PROJECT_HEADER_LIST":
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default projectHeaderReducer;
  